import { render, staticRenderFns } from "./statusLabels.vue?vue&type=template&id=11b9c2a5"
import script from "./statusLabels.vue?vue&type=script&lang=js"
export * from "./statusLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports